import { Component } from '@angular/core';
import {Observable} from "rxjs";
import {HttpClientService} from "../../../../core/services/http-client.service";
import {ToastService} from "../../../../core/services/toast.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";


@Component({
  selector: 'app-reach-us',
  templateUrl: './reach-us.component.html',
  styleUrls: ['./reach-us.component.css']
})
export class ReachUsComponent {
   message: string;
   mobile: number;
   email: string;
   name: string;
  contactForm: FormGroup;

  constructor(private http: HttpClientService,private toast: ToastService,private fb: FormBuilder) {
  }
  ngOnInit(): void {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      message: ['', Validators.required]
    });
  }
  sendContactUs(message: string, mobile: Number, name:string,email:string,):Observable<any> {
    return this.http.post('contact-us', { message: message, mobile: mobile, name:name,email:email, });
  }
  sendMessage() {
    if (this.contactForm.valid) {
      const { name, email, mobile, message } = this.contactForm.value;
      this.sendContactUs(message, mobile, name, email).subscribe(
        (data) => {
          if (data.responseStatus === 'SUCCESS' && data.response) {
            this.contactForm.reset(); // Reset the form
            this.toast.success('Your message has been sent successfully!');
          } else {
            this.toast.error('Some problem occurred. Please try again');
          }
        },
        (err) => {
          this.toast.error('Some problem occurred. Please try again');
        }
      );
    } else {
      // Optionally, you can display validation errors to the user
      this.toast.error('Please fill out all required fields correctly.');
    }
  }
}
